import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect } from "react";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import FormItemInput from "../../components/form-item/form-item-input";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import FormButton from "../../components/FormButton";
import { useNotify } from "../../helper/notify";
import { requireRules } from "../../helper/method";
import { statusShowMock, tokenMock } from "../../helper/mock";
import { $api } from "../../helper";
import { useNavigate, useSearchParams } from "react-router";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";

export default function AddCourseFeature() {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const notify = useNotify();
  const navigate = useNavigate();
  const { mutate, isPending } = $api.useMutation(
    "post",
    "/site-api/v1/course-attribute/",
  );
  const update = $api.useMutation("put", "/site-api/v1/course-attribute/");
  const detail = $api.useMutation(
    "get",
    "/site-api/v1/course-attribute-detail/",
  );
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ایجاد ویژگی دوره");
    if (searchParams.get("u_id")) {
      detail.mutate({
        params: {
          query: {
            course_attribute_u_id: searchParams.get("u_id") ?? "",
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (detail.data?.data) {
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
    }
  }, [detail.data]);

  const onFinish = (
    values: {
      title: string;
      status: string;
    },
    redirect = true,
  ) => {
    if (!searchParams.get("u_id")) {
      mutate(
        {
          body: { ...values, status: +values.status },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/manage-course-features");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      update.mutate(
        {
          body: {
            ...values,
            course_attribute_u_id: searchParams.get("u_id") ?? "",
            status: +values.status,
          },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/manage-course-features");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e, true)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <CustomBreadcrumb
        items={[
          {
            title: "ویژگی های دوره",
            href: "/manage-course-features",
          },
          {
            title: "ایجاد ویژگی",
          },
        ]}
      />
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به ویژگی دوره"
        title="اطلاعات اصلی ویژگی دوره"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            name={"title"}
            rules={requireRules("عنوان")}
            className="col-span-1"
            label="عنوان"
            inputProps={{
              placeholder: "لطفا عنوان خود را وارد کنید.",
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            rules={requireRules("وضعیت")}
            name={"status"}
            label="وضعیت"
            inputProps={{
              placeholder: "لطفا وضعیت نمایش محصول خود را انتخاب کنید.",
              options: statusShowMock,
            }}
          />
        </div>
      </FormCard>
      <FormButton
        isPending={isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
